import { EMPTY_FUNCTION } from '../../../constants';

import { FiltersContextProps } from './types';

export const default_filters_context: FiltersContextProps = {
  queries: {},
  filters: {},
  updateFilters: EMPTY_FUNCTION,
  updateQueries: EMPTY_FUNCTION,
  onSubmit: EMPTY_FUNCTION,
};
